export class MemberAdRequest {
    adImageId: string;
    url: string;
    adNotes: string;
    adType: number;
    runDate: Date

    constructor(adImageId: string, adNotes: string, adType: number, adUrl: string, adRunDate: Date) {
        this.adImageId = adImageId;
        this.adNotes = adNotes;
        this.adType = adType;
        this.url = adUrl;
        this.runDate = adRunDate;
    }
}